import { Box, Button, styled } from "@mui/material";

export const GroupsSearchBarStyles = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "2em",
  width: "100%",
  boxSizing: "border-box"
});


export const ActionBtnsListStyles = styled(Box)({
  display: "flex",
  height: "100%",
  gap: "12px",
});

export const MoreActionsBtnStyles = styled(Button)(({ theme }) => ({
  width: "60px",
  height: "100%",
  minWidth: "0",
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: "5px",
  display: "flex",
  gap: "5px",
  justifyContent: "center",
  alignItems: "flex-end",
  fontSize: "1rem",
  span: {
    width: "5px",
    height: "5px",
    borderRadius: "50%",
    backgroundColor: theme.palette.border.main,
    "&:last-child": {
      background: "none",
    },
  },
}));

export const ActionsPopupBoxStyles = styled(Box)({
  width: "100%",
  maxWidth: "276px",
  display: "flex",
  flexWrap: "wrap",
  gap: "12px",
  padding: "12px",
});

export const ActionButtonWrapperStyles = styled(Box)(({ theme }) => ({
  position: "relative",
  "& > .MuiButtonBase-root": {
    cursor: "default",
    width: "60px",
    minWidth: "0",
    border: `1px solid ${theme.palette.border.main}`,
  },
  ".MuiBox-root": {
    position: "absolute",
    top: "-4.5px",
    right: "-4.5px",
    ".MuiButtonBase-root": {
      padding: "0",
      minWidth: "0",
      width: "fit-content",
      height: "auto!important",
      background: theme.palette.backgroundColor.main,
      borderRadius: "50%",
      svg: {
        width: "18px",
        height: "18px",
      },
    },
  },
}));
